// ErrorNotifier.jsx
import ClassNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux'

import DomText from './DomText';
import ErrorMessage from './notifier/ErrorMessage';
import { getTranslator } from '../locales';
import { clearAlert } from '../redux/actions/alertAction';
import { closeUI } from '../redux/actions/chatInitAction';

@connect((Store) => {
  const t = getTranslator();

  return {
    labels: {
      RELOAD_CHAT_CLICK: t.t('Click to reload Live Chat'),
    },
    error: Store.alert.error,
    warning: Store.alert.warning,
    notification: Store.alert.notification,
    sticky: Store.alert.sticky,
    showReload: Store.alert.showReload
  };
})

export default class ErrorNotifier extends React.Component {
  /**
   * Indicates whether the alert type is a notification.
   * @return {Boolean}
   */
  isNotification() {
    if (this.props.notification) {
      return Boolean(this.props.notification);
    }
  }

  /**
   * Indicates whether the alert type is a warning.
   * @return {Boolean}
   */
  isWarning() {
    if (this.props.warning) {
      return Boolean(this.props.warning);
    }
  }

  /**
   * Indicates whether the alert type is an error.
   * @return {Boolean}
   */
  isError() {
    if (this.props.error) {
      return Boolean(this.props.error);
    }
  }

  /**
   * @return {String|Boolean}
   */
  getText() {
    if (this.isError()) {
      return this.props.error;
    } else if (this.isWarning()) {
      return this.props.warning;
    } else if (this.isNotification()) {
      return this.props.notification;
    } else {
      return false;
    }
  }

  reloadChatClick() {
    window.location.reload();
  }

  render() {
    const text = this.getText();

    const itemClass = ({
      'hidden': (!text),
      'notifier': true,
      'error': (this.props.error ? true : false),
      'warning': (!this.props.error && this.props.warning ? true : false),
      'notification': (!this.props.error && !this.props.warning && this.props.notification ? true : false)
    });

    if (text) {
      if (!this.isError() && !this.props.sticky) {
        setTimeout(() => {
          // will erase the warning OR notification message after X seconds
          this.props.dispatch(clearAlert());
        }, 5000);
      }
    }

    const formattedText = this.isError() ? <ErrorMessage /> : <DomText text={text} />;

    return (
      <div>
        <div className={ClassNames(itemClass)}>
          <p>
            {formattedText}
            {
              (() => {
                if (this.props.showReload && text) {
                  return (
                      <a href="#" onClick={this.reloadChatClick.bind(this)}>{this.props.labels.RELOAD_CHAT_CLICK}</a>
                  );
                }
              })()
            }
          </p>
        </div>
        {
          (() => {
            if (this.props.sticky && text) {
              return (
                <div className={ClassNames('overlay')} />
              );
            }
          })()
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorNotifier.jsx